import { sendGetRequest } from '@/services/api.service'
import { API_EMAIL, API_EMAIL_BO_API } from '@/config/api.config'

export const getEmail = emailToken => {
  return sendGetRequest(`${API_EMAIL.DEFAULT_API_URL}?token=${API_EMAIL.DEFAULT_TOKEN}&email_token=${emailToken}`)
}

export const getEmailBoAPI = emailToken => {
  return sendGetRequest(
    `${API_EMAIL_BO_API.DEFAULT_API_URL}${API_EMAIL_BO_API.EMAIL_DATA}?token=${API_EMAIL_BO_API.DEFAULT_TOKEN}&email_token_boapi=${emailToken}`
  )
}
